import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-bank-info-box',
  templateUrl: './add-bank-info-box.component.html',
  styleUrls: ['./add-bank-info-box.component.scss']
})
export class AddBankInfoBoxComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
